import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
/**
 * Hint visual de atalho de teclado, tipografia mono.
 * Ex.: <KbdHint keys={['G', 'A']} /> → "G A"  (vai para Agenda)
 *      <KbdHint keys={['⌘', 'K']} /> → "⌘ K"  (command palette)
 */
export function KbdHint({ keys, className }) {
    return (_jsx("span", { className: cn('inline-flex items-center gap-1', className), children: keys.map((k, i) => (_jsx("kbd", { className: cn('inline-flex items-center justify-center min-w-[20px] h-5 px-1.5', 'rounded-ax-sm border border-ax-line bg-ax-night', 'font-mono text-[10px] text-ax-text-secondary'), children: k }, `${k}-${String(i)}`))) }));
}
//# sourceMappingURL=KbdHint.js.map